var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-stepper-content",
    { class: _vm.$style.stepperContent, attrs: { step: 7 } },
    [
      _c("div", { class: _vm.$style.orderMain }, [
        _c("div", { class: _vm.$style.orderMainInfo }, [
          _c(
            "div",
            { class: _vm.$style.backBtnContainer },
            [
              _c(
                "BaseButton",
                {
                  class: _vm.$style.orderBackBtn,
                  attrs: { "button-style": "Back" },
                  on: { click: _vm.previousStep }
                },
                [
                  _c("svg", {
                    directives: [{ name: "svg", rawName: "v-svg" }],
                    class: _vm.$style.backIcon,
                    attrs: { symbol: "straight-arrow" }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Back")])
                ]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _c("p", { class: _vm.$style.orderMainStep }, [_vm._v("Optional")]),
          _vm._v(" "),
          _c("div", { class: _vm.$style.orderMainTitle }, [
            _c("h2", [_vm._v("Would you like to add fries?")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { class: _vm.$style.dialogButtons },
            [
              _c(
                "BaseButton",
                {
                  class: _vm.$style.orderBackBtn,
                  attrs: { "button-style": "Back" },
                  on: { click: _vm.nextStep }
                },
                [_vm._v("\n          Yes\n        ")]
              ),
              _vm._v(" "),
              _c(
                "BaseButton",
                {
                  class: _vm.$style.orderBackBtn,
                  attrs: { "button-style": "Back" },
                  on: { click: _vm.finishOrderWithNoBundleItem }
                },
                [_vm._v("\n          No\n        ")]
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _vm.isLoading ? _c("LoadingSpinner") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/configurator/components/ConfiguratorStepBundleDialog.vue?vue&type=template&id=307c8684&
// module id = null
// module chunks = 